<!-- src/App.vue -->
<template>
  <BlogItem />

</template>

<script setup>
import BlogItem from "../components/BlogItem";

import { useHead } from '@vueuse/head'

useHead({
  title: 'Grapefroot | Blogs',
  meta: [
    {
      name: 'description',
      content: 'Meta description',
    },
  ],
})


</script>
